var map = {
	"./logo1.png": 355,
	"./logo2.png": 5080,
	"./logo3.png": 2945,
	"./logo4.png": 1934,
	"./logo5.png": 247,
	"./logo6.png": 188,
	"./logo7.png": 9285,
	"./logo8.png": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7474;